import { cn } from "@/utils/cn";

export const interactiveStyles = cn(
  "touch-manipulation select-none transition-[transform,border-color,background-color,color,opacity,box-shadow] duration-[var(--duration-fast)] ease-out-expo motion-reduce:transition-none",
  "active:enabled:scale-[0.96]",
  "focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-primary",
  "disabled:cursor-not-allowed disabled:opacity-50",
);

export const primaryButtonStyles = cn(
  "inline-flex min-h-11 cursor-pointer items-center justify-center gap-2 rounded-md border-0 bg-accent px-4 py-2.5 text-body-sm leading-none font-bold text-accent-foreground shadow-[0_1px_2px_var(--shadow-color)] min-[42.501rem]:min-h-10 min-[42.501rem]:py-2",
  "touch-manipulation select-none transition-[transform,background-color,filter,opacity,box-shadow] duration-[var(--duration-fast)] ease-out-expo motion-reduce:transition-none",
  "hover:brightness-95 hover:shadow-[0_3px_10px_var(--shadow-color)]",
  "focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-primary",
  "active:enabled:scale-[0.96]",
  "disabled:cursor-not-allowed disabled:shadow-none disabled:opacity-55",
);

export const secondaryButtonStyles = cn(
  "inline-flex min-h-11 cursor-pointer items-center justify-center gap-2 rounded-md border border-border bg-surface px-3.5 py-2.5 text-label leading-none font-extrabold text-foreground min-[42.501rem]:min-h-10 min-[42.501rem]:py-2",
  "touch-manipulation select-none transition-[transform,border-color,background-color,color,opacity,box-shadow] duration-[var(--duration-fast)] ease-out-expo motion-reduce:transition-none",
  "hover:border-primary/55 hover:bg-surface-muted",
  "focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-primary",
  "active:enabled:scale-[0.96]",
  "disabled:cursor-not-allowed disabled:opacity-50",
);

export const tabButtonStyles = cn(
  "inline-flex min-h-11 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full border-0 bg-transparent px-3.5 py-2.5 text-label leading-none font-bold text-muted min-[42.501rem]:min-h-10 min-[42.501rem]:py-2",
  "touch-manipulation select-none transition-[transform,background-color,color,opacity] duration-[var(--duration-fast)] ease-out-expo motion-reduce:transition-none",
  "hover:bg-surface-muted hover:text-foreground",
  "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
  "active:enabled:scale-[0.96]",
  "disabled:cursor-not-allowed disabled:opacity-50",
);

export const activeTabStyles = "bg-foreground text-background";

export const segmentedControlStyles = cn(
  "segmented-control relative isolate inline-flex max-w-full items-center gap-[var(--segmented-gap)] overflow-x-auto rounded-[var(--segmented-radius)] border border-border bg-surface-muted p-[var(--segmented-padding)] shadow-[inset_0_1px_0_color-mix(in_srgb,var(--surface-raised)_72%,transparent)]",
  "[scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
);

export const segmentedControlItemStyles = cn(
  tabButtonStyles,
  "relative z-[1] shrink-0 rounded-[var(--segmented-item-radius)] border border-transparent bg-transparent shadow-none",
  "transition-[transform,border-color,background-color,color,opacity,box-shadow]",
  "hover:bg-surface-raised hover:text-foreground",
  "data-[size=compact]:min-h-[34px] data-[size=compact]:px-2.5 data-[size=compact]:py-1.5",
);

export const fieldStyles = cn(
  "min-h-11 w-full rounded-md border border-field-border bg-field px-3 py-2.5 font-sans text-body leading-normal text-field-foreground outline-none min-[42.501rem]:min-h-10 min-[42.501rem]:py-2 min-[42.501rem]:text-body-sm",
  "caret-primary placeholder:text-field-placeholder selection:bg-accent selection:text-accent-foreground",
  "transition-[border-color,box-shadow,background-color,color,opacity] duration-[var(--duration-fast)] ease-out-expo motion-reduce:transition-none",
  "hover:border-border-strong focus:border-primary focus:ring-2 focus:ring-primary/15",
  "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
  "aria-invalid:border-danger aria-invalid:focus:ring-danger/15 aria-invalid:focus-visible:outline-danger",
  "disabled:cursor-not-allowed disabled:border-border disabled:bg-surface-muted disabled:text-muted disabled:opacity-100",
  "read-only:bg-surface-muted read-only:text-muted",
);
